import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { notificar } from '../utils/notify';
import '../styles/fmp.css';

const Reunioes = () => {
  const [cliente, setCliente] = useState(null);
  const [anotacoes, setAnotacoes] = useState('');
  const [utilizouBi, setUtilizouBi] = useState('');
  const [qualidade, setQualidade] = useState('');
  const [mensagem, setMensagem] = useState('');

  useEffect(() => { notificar(mensagem); }, [mensagem]);
  const [salvandoReuniao, setSalvandoReuniao] = useState(false);
  const [reunioes, setReunioes] = useState([]);
  const [carregandoReunioes, setCarregandoReunioes] = useState(false);
  const [reuniaoExpandida, setReuniaoExpandida] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const dados = localStorage.getItem('reuniao_cliente');
    if (dados) {
      const clienteData = JSON.parse(dados);
      setCliente(clienteData);
      carregarReunioes(clienteData.numero_dominio);
    }
  }, []);

  const carregarReunioes = async (numero_dominio) => {
    if (!numero_dominio) return;
    setCarregandoReunioes(true);
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/listar-reunioes-contabil/?numero_dominio=${numero_dominio}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.success) {
        setReunioes(response.data.reunioes);
      }
    } catch {
      // silencia erro de listagem
    } finally {
      setCarregandoReunioes(false);
    }
  };

  const salvarReuniao = async () => {
    if (!anotacoes.trim()) {
      setMensagem('Preencha as anotações antes de salvar.');
      return;
    }

    setSalvandoReuniao(true);
    setMensagem('');

    const accessToken = localStorage.getItem('access');

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/salvar-reuniao/`,
        {
          numero_dominio: cliente?.numero_dominio,
          empresa: cliente?.empresa,
          operador: cliente?.operador,
          conteudo_reuniao: anotacoes,
          utilizou_bi: utilizouBi,
          qualidade_reuniao: qualidade,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (response.data.success) {
        setMensagem('Reunião salva com sucesso!');
        setAnotacoes('');
        setUtilizouBi('');
        setQualidade('');
        carregarReunioes(cliente?.numero_dominio);
        setTimeout(() => setMensagem(''), 3000);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.mensagem || 'Erro ao salvar reunião';
      setMensagem(`Erro: ${errorMsg}`);
    } finally {
      setSalvandoReuniao(false);
    }
  };

  const voltar = () => navigate('/Contabilidade');

  const getBadgeQualidade = (q) => {
    const map = {
      'Ótima': 'success',
      'Boa': 'primary',
      'Regular': 'warning',
      'Ruim': 'danger',
    };
    return map[q] || 'secondary';
  };

  return (
    <div className="das-page">
      <div className="container-fluid mt-4">

        {/* Header */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #ffffff 0%, #ffffff 100%)' }}>
              <div className="card-body text-dark">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1">
                    <div className="mb-3">
                      <span className="badge bg-warning text-dark" style={{ fontSize: '14px', fontWeight: '500' }}>
                        <i className="fas fa-video me-1"></i>
                        Reunião com Cliente
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-1">
                      <i className="fas fa-sticky-note header-icon me-2"></i>
                      <h2 className="titulo-pagina m-0">Reuniões BI Estratégico & Consultivo</h2>
                    </div>
                    <p className="mb-0 opacity-75">
                      <i className="fas fa-pencil-alt me-2"></i>
                      Anotações e avaliação da reunião
                    </p>
                  </div>
                  <div>
                    <button
                      className="btn btn-sm"
                      onClick={voltar}
                      style={{ backgroundColor: '#00205b', borderColor: '#00205b', color: '#fff' }}
                    >
                      <i className="fas fa-arrow-left me-1"></i>
                      Voltar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mensagens agora são exibidas como toast (react-toastify) */}

        {/* Dados do Cliente */}
        {cliente ? (
          <div className="row mb-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white">
                  <h5 className="card-title mb-0">
                    <i className="fas fa-building me-2 text-primary"></i>
                    Informações do Cliente
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4 mb-2">
                      <h6 className="text-primary mb-0">
                        <i className="fas fa-briefcase me-2"></i>
                        {cliente.empresa}
                        <span className="ms-2 badge bg-light text-dark">Nº {cliente.numero_dominio}</span>
                      </h6>
                    </div>
                  </div>
                  <div className="row g-3 mt-1">
                    {[
                      { label: 'Operador', value: cliente.operador },
                      { label: 'Regime', value: cliente.regime },
                      { label: 'Tipo Entrega', value: cliente.tipo_entrega },
                      { label: 'Última Entrega', value: cliente.ultima_entrega },
                      { label: 'Próxima Entrega', value: cliente.proxima_entrega },
                    ].map((item, i, arr) => (
                      <div key={item.label} className={`col-md-2 text-center ${i < arr.length - 1 ? 'border-end' : ''}`}>
                        <h6 className="text-muted small mb-1">{item.label}</h6>
                        <h6 className="mb-0">{item.value || '-'}</h6>
                      </div>
                    ))}
                    <div className="col-md-2 text-center">
                      <h6 className="text-muted small mb-1">Status Contábil</h6>
                      <span className={`badge ${cliente.Status_contabil?.includes('Atrasado') ? 'bg-danger' : 'bg-success'}`}>
                        {cliente.Status_contabil || '-'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row mb-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm">
                <div className="card-body text-center py-4">
                  <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
                  <h5 className="text-muted">Nenhum Cliente Selecionado</h5>
                  <p className="text-muted mb-0">Volte para a Contabilidade e clique no ícone de reunião ao lado do cliente.</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Formulário de Nova Reunião */}
        <div className="row g-4 mb-4">
          {/* Anotações */}
          <div className="col-md-8">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-white d-flex justify-content-between align-items-center">
                <span>
                  <i className="fas fa-sticky-note me-2"></i>
                  Anotações da Reunião
                </span>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setAnotacoes('')}
                  disabled={!anotacoes}
                  title="Limpar anotações"
                  aria-label="Limpar anotações"
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
              <div className="card-body d-flex flex-column">
                <textarea
                  className="form-control flex-fill"
                  style={{ minHeight: '320px', resize: 'vertical', fontSize: '0.95rem' }}
                  placeholder="Digite suas anotações sobre a reunião..."
                  value={anotacoes}
                  onChange={(e) => setAnotacoes(e.target.value)}
                />
                <small className="text-muted mt-2">{anotacoes.length} caracteres</small>
              </div>
            </div>
          </div>

          {/* Avaliação */}
          <div className="col-md-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-white">
                <i className="fas fa-star me-2"></i>
                Avaliação da Reunião
              </div>
              <div className="card-body d-flex flex-column gap-4 pt-4">
                <div>
                  <label className="form-label fw-semibold">
                    <i className="fas fa-chart-bar me-2 text-primary"></i>
                    Utilizou BI?
                  </label>
                  <select
                    className="form-select"
                    value={utilizouBi}
                    onChange={(e) => setUtilizouBi(e.target.value)}
                  >
                    <option value="">Selecione...</option>
                    <option value="Sim">Sim</option>
                    <option value="Não">Não</option>
                  </select>
                </div>

                <div>
                  <label className="form-label fw-semibold">
                    <i className="fas fa-thumbs-up me-2 text-success"></i>
                    Qualidade da Reunião
                  </label>
                  <select
                    className="form-select"
                    value={qualidade}
                    onChange={(e) => setQualidade(e.target.value)}
                  >
                    <option value="">Selecione...</option>
                    <option value="Ótima">Ótima</option>
                    <option value="Boa">Boa</option>
                    <option value="Regular">Regular</option>
                    <option value="Ruim">Ruim</option>
                  </select>
                </div>

                <div className="mt-auto">
                  <div className="d-grid gap-2">
                    <button
                      className="btn btn-success"
                      onClick={salvarReuniao}
                      disabled={salvandoReuniao || !anotacoes.trim()}
                    >
                      {salvandoReuniao ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          Salvando...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-save me-2"></i>
                          Salvar Reunião
                        </>
                      )}
                    </button>
                    <button className="btn btn-outline-secondary" onClick={voltar} disabled={salvandoReuniao}>
                      <i className="fas fa-times me-2"></i>
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Histórico de Reuniões */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-white d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">
                  <i className="fas fa-history me-2 text-primary"></i>
                  Reuniões Anteriores
                  {reunioes.length > 0 && (
                    <span className="badge bg-primary ms-2">{reunioes.length}</span>
                  )}
                </h5>
                {carregandoReunioes && (
                  <span className="spinner-border spinner-border-sm text-primary" role="status"></span>
                )}
              </div>
              <div className="card-body p-0">
                {!carregandoReunioes && reunioes.length === 0 ? (
                  <div className="text-center py-5 text-muted">
                    <i className="fas fa-calendar-times fa-3x mb-3 opacity-50"></i>
                    <p className="mb-0">Nenhuma reunião registrada para este cliente.</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Data</th>
                          <th>Operador</th>
                          <th>BI</th>
                          <th>Qualidade</th>
                          <th>Anotações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reunioes.map((r) => (
                          <React.Fragment key={r.id}>
                            <tr
                              style={{ cursor: 'pointer' }}
                              role="button"
                              tabIndex={0}
                              onClick={() => setReuniaoExpandida(reuniaoExpandida === r.id ? null : r.id)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault();
                                  setReuniaoExpandida(reuniaoExpandida === r.id ? null : r.id);
                                }
                              }}
                            >
                              <td>
                                <i className="fas fa-calendar me-1 text-muted"></i>
                                {r.data_reuniao}
                              </td>
                              <td>{r.operador}</td>
                              <td>
                                <span className={`badge ${r.utilizou_bi === 'Sim' ? 'bg-success' : r.utilizou_bi === 'Não' ? 'bg-secondary' : 'bg-light text-dark'}`}>
                                  {r.utilizou_bi}
                                </span>
                              </td>
                              <td>
                                <span className={`badge bg-${getBadgeQualidade(r.qualidade_reuniao)}`}>
                                  {r.qualidade_reuniao}
                                </span>
                              </td>
                              <td>
                                <small className="text-muted">
                                  {reuniaoExpandida === r.id
                                    ? <i className="fas fa-chevron-up"></i>
                                    : <i className="fas fa-chevron-down"></i>
                                  }
                                  <span className="ms-2">
                                    {r.anotacoes.length > 60 && reuniaoExpandida !== r.id
                                      ? r.anotacoes.substring(0, 60) + '...'
                                      : r.anotacoes.substring(0, 60) + (r.anotacoes.length > 60 ? '...' : '')}
                                  </span>
                                </small>
                              </td>
                            </tr>
                            {reuniaoExpandida === r.id && (
                              <tr>
                                <td colSpan="5" className="bg-light">
                                  <div className="p-3">
                                    <div className="d-flex justify-content-between mb-2">
                                      <small className="text-muted">
                                        <i className="fas fa-clock me-1"></i>
                                        Registrado em: {r.criado_em}
                                      </small>
                                    </div>
                                    <p className="mb-0" style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '0.9rem' }}>
                                      {r.anotacoes}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Reunioes;
